import { ReadAdminDashboardUnstakeType } from '@/types';
import { Tables } from '../pools/table/Tables';
import { GridColDef } from '@mui/x-data-grid';
import { UserDashboardStakeListTableColumns, UserDashboardUnstakeListTableColumns } from '../pools/table/ColumnsData';
import { Button, Typography } from '@mui/material';
import { now } from '@/lib/dayjs';
import { fontWeight } from '@/theme';

export default function UnStakeList({ list }: { list: ReadAdminDashboardUnstakeType[] | undefined }) {
  if (!list) {
    return <>unstake empty</>;
  }
  const addListTableColumns: GridColDef[] = [
    ...UserDashboardUnstakeListTableColumns,
    {
      minWidth: 200,
      field: 'shortTxHash',
      headerName: 'hash',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" onClick={() => handleButtonClick(params.row.hash)}>
          {params.row.shortTxHash}
        </Button>
      ),
    },
  ];

  const handleButtonClick = (aData: string) => {
    const src =
      process.env.NODE_ENV === 'development'
        ? `https://amoy.polygonscan.com/tx/${aData}`
        : `https://polygonscan.com/tx/${aData}`;
    window.open(src);
  };
  return (
    <>
      <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="left">
        Unstake
      </Typography>
      <Tables list={list} columns={addListTableColumns} csvName={`unstake-${now()}`} />
    </>
  );
}
